import type { PaymentDetailDto } from "@repo/types";
import { useQuery } from "@tanstack/react-query";
import { getPaymentDetail } from "../api/paymentApi";

export const usePaymentDetail = (id: number | null) => {
  return useQuery<PaymentDetailDto>({
    queryKey: ["paymentDetail", id],
    queryFn: () => {
      if (id === null) {
        throw new Error("결제 ID가 없습니다.");
      }
      return getPaymentDetail(id);
    },
    enabled: id !== null,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};





